import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["tab", "panel"];
  declare tabTargets: HTMLElement[];
  declare panelTargets: HTMLElement[];

  connect() {
    this.activateTabFromHash();
  }

  onSelect(evt: Event) {
    evt.preventDefault();

    const targetTab = evt.currentTarget as HTMLElement;

    window.location.hash = `#${targetTab.id.replace("tab-", "")}`;
  }

  handlePopState() {
    this.activateTabFromHash();
  }

  private activateTabFromHash() {
    const selectedKey = window.location.hash.replace("#", "");

    let desiredTab: HTMLElement | undefined;

    if (selectedKey) {
      desiredTab = this.tabTargets.find((tab) => tab.id === `tab-${selectedKey}`);
    }

    if (!desiredTab) {
      desiredTab = this.tabTargets[0];
    }

    this.tabTargets.forEach((tab) => tab.setAttribute("aria-selected", "false"));
    desiredTab.setAttribute("aria-selected", "true");

    this.panelTargets.forEach((pane) => pane.setAttribute("hidden", "true"));

    const controlledPanelId = desiredTab.getAttribute("aria-controls");
    if (controlledPanelId) {
      const controlledPanel = this.element.querySelector(`#${controlledPanelId}`);
      controlledPanel?.removeAttribute("hidden");
    }
  }
}
